module.exports = __webpack_public_path__ + "static/media/feature-approvals.6e0c6180.png";